module.exports = __webpack_public_path__ + "img/super_wild_win.8e2bf035.png";